import { Observable } from 'rxjs';
import Audit from '../interfaces/audit';

import Paginate from '../interfaces/paginate';
import User from '../interfaces/user';
import { HttpClient, ListParams } from './http-client';

export class AuditService extends HttpClient {
  index(params: ListParams): Observable<Paginate<Audit>> {
    return this.get<Paginate<Audit>>('/api/internal/audits', params);
  }

  show(id: string): Observable<Audit> {
    return this.get<Audit>(`/api/internal/audits/${id}`);
  }

  initiatorUsers(): Observable<User[]> {
    return this.get<User[]>(`/api/internal/audits/initiatorUsers`);
  }

  availableEvents(): Observable<string[]> {
    return this.get<string[]>(`/api/internal/audits/availableEvents`);
  }

  availableAuditableTypes(): Observable<string[]> {
    return this.get<string[]>(`/api/internal/audits/availableAuditableTypes`);
  }
}
